import type { ConsoleEntry } from "../types";

const MAX_ENTRIES = 100;
const LEVELS = ["log", "info", "warn", "error", "debug"] as const;
type Level = (typeof LEVELS)[number];

const buffer: ConsoleEntry[] = [];

function format(args: unknown[]): string {
  return args
    .map((a) => {
      if (a == null) return String(a);
      if (typeof a === "string") return a;
      if (a instanceof Error) return `${a.name}: ${a.message}`;
      try {
        return JSON.stringify(a);
      } catch {
        return String(a);
      }
    })
    .join(" ")
    .slice(0, 4000);
}

let installed = false;

export function startConsoleCapture(): void {
  if (installed) return;
  installed = true;

  for (const level of LEVELS) {
    const original = (console[level] as (...args: unknown[]) => void).bind(console);
    (console[level] as (...args: unknown[]) => void) = (...args: unknown[]) => {
      try {
        buffer.push({ level, message: format(args), timestamp: Date.now() });
        if (buffer.length > MAX_ENTRIES) buffer.splice(0, buffer.length - MAX_ENTRIES);
      } catch {
        // Never let capture break the host app.
      }
      original(...args);
    };
  }
}

export function snapshotConsole(): ConsoleEntry[] {
  return buffer.slice();
}

// Re-export for callers that need to filter.
export type { Level };
